module.exports = __webpack_public_path__ + "img/lower-left.4eed5495.svg";